import { Injectable, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Delegation } from '../models/delegation.model';
import { map } from 'rxjs/operators';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class DelegationService {
    private url = environment.url;

    constructor(private http: HttpClient, private userService: UserService) { }

    createDelegation(delegation: Delegation) {
        return this.http.post(this.url + 'cost/delegation', delegation);
    }

    fetchDelegation(id) {
        return this.http.get<Delegation>(this.url + 'cost/delegation/' + id);
    }

    fetchDelegations() {
        return this.http.get<Delegation[]>(this.url + 'company/delegations').pipe(
            map(v => v.map(Delegation.adapt))
        );
    }

    fetchEmployeeDelegations(employeeId: number) {
        return this.http.get<Delegation[]>(this.url + 'employee/' + employeeId + '/delegations').pipe(
            map(v => v.map(Delegation.adapt))
        );
    }

    fetchCurrentUserDelegations() {
        return this.http.get<Delegation[]>(this.url + 'employee/' + this.userService.getCurrentUserId() + '/delegations').pipe(
            map(v => v.map(Delegation.adapt))
        );
    }

  fetchDelegationsByStatus(status: string) {
    return this.http.get<Delegation[]>(`${this.url}company/delegations/${status}`).pipe(
      map(v => v.map(Delegation.adapt))
    );
  }
}
